// This fix IE event.target with SVG use element where it's shadow dom internals is revealed: the given target is an SVGElementInstance instead of the SVGUseElement itself
// SVGElementIntance has been removed from SVG2 spec
// https://bugs.jquery.com/ticket/13180 and https://github.com/jquery/jquery/issues/3877#issuecomment-349706832
// https://groups.google.com/a/chromium.org/forum/#!topic/chromium-bugs/AeSY6qzKm4E
// Note: some browsers support window.SVGElementInstance but target don't return svg element instance. But support getOwnPropertyDescriptor for Event.prototype but not event.srcElement https://bugzilla.mozilla.org/show_bug.cgi?id=265895
// Note: some browsers event target return svg element instance but can't get property descriptor for Event.prototype (Android stock browser)
var supportDescriptors = require('core-js/internals/descriptors');
var defineProperty = require('core-js/internals/object-define-property').f;
var getOwnPropertyDescriptor = require('core-js/internals/object-get-own-property-descriptor').f;
var NAME = 'target';
var proto = Event.prototype;

if (supportDescriptors && window.SVGElementInstance) {
  var desc = getOwnPropertyDescriptor(proto, NAME);
  defineProperty(proto, NAME, {
    configurable: true,
    get: desc ? function() {
      var target = desc.get.call(this);
      return target && target.correspondingUseElement || target;
    } : function() {
      var target = this.srcElement;
      return target && target.correspondingUseElement || target;
    }
  });
}
